<template>
	<v-row>
		<v-col>
			<v-form v-model="formIsValid" ref="form">

				<pass-common-section
						:newPass="admission"
						:rules="rules"
						:showSections="showSections"
						:formProductRequirementsMessages="formProductRequirementsMessages"
				>
				</pass-common-section>


				<!-- More Button -->
				<v-row>
					<v-col>
						<v-btn
								class="mb-6 ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								@click="switchAdvancedSection"
						>
							{{ shouldShowSection('advanced') ? 'Less...' : 'More...' }}
						</v-btn>

					</v-col>
				</v-row>
				<!-- End: More Button -->


				<ui-box v-if="shouldShowSection('advanced') && shouldShowSection('image')">
					<!-- Advanced Image -->
					<h5>Mobile Pass Header Image</h5>
					<span class="grey--text text--darken-1 text-body-2">
					</span>

					<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

					<v-row>
						<bw-image
								v-model="admission.media[0]"
								class="rounded-lg"
								:upload-assignment="'deal'"
								:upload-assignment-id="admission.id"
						></bw-image>
						<span class="red--text">*</span>
					</v-row>

					<!-- End: Advanced Image -->

				</ui-box>

				<!-- Advanced Pass Configuration -->

				<pass-redemption-policy-section
						:newPass="admission"
						:pass="pass"
						:show-sections="showSections"
						:rules="rules"
				></pass-redemption-policy-section>

				<!-- End: Advanced Pass Configuration -->


				<!-- Pricing -->
				<ui-box
						v-if="shouldShowSection('advanced') && shouldShowSection('pricing')">
					<h5>Pricing</h5>
					<span class="grey--text text--darken-1 text-body-2">
					</span>

					<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

					<v-row>
						<v-col>
							<v-switch
									v-model="usePricingTiers"
									class="mt-3"
									dense
									hide-details="auto"
									inset
									label="Use admission pricing tiers?"
							></v-switch>

						</v-col>
					</v-row>
					<v-row v-if="!usePricingTiers">
						<v-col cols="12" sm="4">
							<v-text-field
									v-model.number="admission.retail_price"
									class="mt-4 mt-sm-0 rounded-lg required"
									label="Retail Price"
									outlined
									persistent-hint
									prefix="$ "
									type="number"
									:rules="rules.retail_price"
									@wheel.native.prevent
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="4">
							<v-row>
								<v-col cols="12" sm="4">
									<v-select
											v-model="admission.convenience_fee_type"
											class="rounded-lg"
											:items="[{name: '$', value: 'fixed'}, {name: '%', value: 'percent'}]"
											item-text="name"
											outlined
									></v-select>
								</v-col>
								<v-col cols="12" sm="8">
									<v-text-field
											v-model.number="admission.convenience_fee"
											class="mt-4 mt-sm-0 rounded-lg"
											label="Convenience Fee"
											outlined
											persistent-hint
											type="number"
											@wheel.native.prevent
									></v-text-field>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4">
							<v-text-field
									v-model.number="admission.tax_rate"
									class="mt-4 mt-sm-0 rounded-lg"
									label="Tax Rate"
									outlined
									persistent-hint
									prefix="% "
									type="number"
									@wheel.native.prevent
							></v-text-field>
						</v-col>
					</v-row>
					<v-row v-if="!usePricingTiers">
						<v-col cols="12" sm="4">
							<v-select
									v-model="admission.paid_on_override"
									class="rounded-lg required"
									label="Paid On Override"
									:items="[{name: 'By Product', value: 'by_product'}, {name: 'On Sale', value: 'sale'}, {name: 'On Redemption', value: 'redemption'}, {name: 'Don\'t pay', value: 'never'}]"
									item-text="name"
									outlined
									:rules="rules.paid_on_override"
							></v-select>
						</v-col>
					</v-row>
					<v-row v-if="usePricingTiers">
						<v-col cols="12" md="6">
							<v-row>
								<v-col>
									<span class="red--text">*</span>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="4" sm="4" md="5">
									<v-text-field
											v-model.number="attributes.adult.retail_price"
											class="rounded-lg"
											label="Adult"
											outlined
											persistent-hint
											prefix="$ "
											type="number"
											@wheel.native.prevent
									></v-text-field>
								</v-col>
								<v-col cols="8" sm="8" md="7">
									<v-text-field
											v-model="attributes.adult.sub_title"
											class="rounded-lg"
											hint="Ex: Ages 13-64"
											label="Adult Subtitle"
											outlined
											persistent-hint
									></v-text-field>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="4" sm="4" md="5">
									<v-text-field
											v-model.number="attributes.child.retail_price"
											class="rounded-lg"
											label="Child"
											outlined
											persistent-hint
											prefix="$ "
											type="number"
											@wheel.native.prevent
									></v-text-field>
								</v-col>
								<v-col cols="8" sm="8" md="7">
									<v-text-field
											v-model="attributes.child.sub_title"
											class="rounded-lg"
											hint="Ex: Ages 0-12"
											label="Child Subtitle"
											outlined
											persistent-hint
									></v-text-field>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="4" sm="4" md="5">
									<v-text-field
											v-model.number="attributes.senior.retail_price"
											class="rounded-lg"
											label="Senior"
											outlined
											persistent-hint
											prefix="$ "
											type="number"
											@wheel.native.prevent
									></v-text-field>
								</v-col>
								<v-col cols="8" sm="8" md="7">
									<v-text-field
											v-model="attributes.senior.sub_title"
											class="rounded-lg"
											hint="Ex: Age 65+"
											label="Senior Subtitle"
											outlined
											persistent-hint
									></v-text-field>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="4" sm="4" md="5">
									<v-text-field
											v-model.number="attributes.student.retail_price"
											class="rounded-lg"
											label="Student"
											outlined
											persistent-hint
											prefix="$ "
											type="number"
											@wheel.native.prevent
									></v-text-field>
								</v-col>
								<v-col cols="8" sm="8" md="7">
									<v-text-field
											v-model="attributes.student.sub_title"
											class="rounded-lg"
											hint="Ex: Must provide school ID"
											label="Student Subtitle"
											outlined
											persistent-hint
									></v-text-field>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="4" sm="4" md="5">
									<v-text-field
											v-model.number="attributes.military.retail_price"
											class="rounded-lg"
											label="Military"
											outlined
											persistent-hint
											prefix="$ "
											type="number"
											@wheel.native.prevent
									></v-text-field>
								</v-col>
								<v-col cols="8" sm="8" md="7">
									<v-text-field
											v-model="attributes.military.sub_title"
											class="rounded-lg"
											label="Military Subtitle"
											outlined
											persistent-hint
									></v-text-field>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea
									v-model="admission.refund_policy"
									auto-grow
									class="rounded-lg"
									hint=""
									label="Refund Policy"
									outlined
									persistent-hint
									rows="4"
							></v-textarea>
						</v-col>
					</v-row>

				</ui-box>

				<!-- End: Pricing -->


				<ui-box v-if="shouldShowSection('advanced') && shouldShowSection('checkout')">
					<!-- Advanced Checkout -->
					<h5>Pre-Purchase Info</h5>
					<span class="grey--text text--darken-1 text-body-2">
					</span>

					<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

					<!-- Learn More Description -->
					<v-row>
						<v-col>
							<span class="grey--text text--darken-1 text-body-2">
								This description will be shown to a customer before they have ordered the pass. Include information about why they should get it!
							</span>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea
									v-model="admission.short_description"
									auto-grow
									class="rounded-lg required"
									counter="250"
									hint=""
									label="Learn More Description"
									outlined
									persistent-hint
									rows="4"
									:rules="rules.short_description"
							></v-textarea>
						</v-col>
					</v-row>
					<!-- End: Learn More Description -->

					<!-- Highlights -->
					<v-row>
						<v-col>
							<span class="grey--text text--darken-1 text-body-2">
								These bullet points will appear on the item card embedded on your website.
							</span>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea
									v-model="admission.highlights"
									auto-grow
									class="rounded-lg required"
									counter="250"
									hint="Add one highlight per line. These will show as bullet points on the checkout cards."
									label="Highlights"
									outlined
									persistent-hint
									rows="4"
									:rules="rules.highlights"
							></v-textarea>
						</v-col>
					</v-row>
					<!-- End: Highlights -->

					<!-- End: Advanced Checkout -->
				</ui-box>

				<!-- Advanced Settings -->

				<pass-settings-section
						:newPass="admission"
						:show-sections="showSections"
						:rules="rules"
				></pass-settings-section>

				<!-- End: Advanced Settings -->


				<save-form
						:is-saving="isSaving"
						:is-valid="validateForm()"
						save-text="Save"
						@cancel-action="cancelChanges"
						@save-action="saveChanges"
				></save-form>

			</v-form>
		</v-col>
	</v-row>
</template>

<script>

import { admissionHelpers, passHelpers } from '../helpers';
import PassCommonSection from '../PassCommonSection.vue';
import PassRedemptionPolicySection from '../PassRedemptionPolicySection.vue';
import PassSettingsSection from '../PassSettingsSection.vue';
import { templateHelpers } from '../../../../templateHelpers';

export default {
	name: 'CheckInEditPass',
	components: { PassSettingsSection, PassRedemptionPolicySection, PassCommonSection },
	props: {
		// The incoming deal from an edit
		pass: {
			type: Object,
			default: () => ({})
		},
		showSections: {
			type: Array,
			default: () => [
				'basic',
				'campaign_dates',
				'product_requirements',
				'image',
				'pass_configuration',
				'pricing',
				'checkout',
				'settings'
			]
		},
		template: {
			type: Object,
			default: () => ({})
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			admission: {
				...cloneDeep(this.pass),
				...{
					highlights: this.pass.highlights || passHelpers.getPassHighlights(),
					redemption_policy: passHelpers.getRedemptionPolicyObject(this.pass),
					media: this.pass.media || [],
					shareable: false,
					transferable: true
				}
			},
			attributes: {
				adult: {
					global_name: 'Adult',
					retail_price: null,
					sub_title: null
				},
				child: {
					global_name: 'Child',
					retail_price: null,
					sub_title: null
				},
				senior: {
					global_name: 'Senior',
					retail_price: null,
					sub_title: null
				},
				student: {
					global_name: 'Student',
					retail_price: null,
					sub_title: null
				},
				military: {
					global_name: 'Military',
					retail_price: null,
					sub_title: null
				}
			},
			usePricingTiers: false,
			isSaving: false,
			formIsValid: false,
			rules: {},
		};
	},
	computed: {
		formProductRequirementsMessages() {
			return passHelpers.productRequirementsErrorMessages(this.admission);
		}
	},
	mounted() {
		this.rules = admissionHelpers.getValidationRules(this.$data);
		templateHelpers.loadAttributes(this.admission, this.attributes);
		this.usePricingTiers = this.admission?.attributes?.length;
	},
	methods: {
		switchAdvancedSection() {
			if(this.shouldShowSection('advanced')) {
				this.showSections.splice(this.showSections.indexOf('advanced'), 1);
			}
			else {
				this.showSections.push('advanced');
			}
		},
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return passHelpers.getReturnUrl(this.returnUrl, this.partner);
		},
		shouldShowSection(section) {
			return !this.showSections.length || this.showSections.includes(section);
		},
		validateForm() {
			const validBasicForm = this.formIsValid && !this.formProductRequirementsMessages.length;
			let priceValid = true;
			if(this.usePricingTiers) {
				const validAttributes = Object.values(this.attributes).filter(attribute => attribute.retail_price > 0)
				priceValid = validAttributes.length > 0;
			}
			const validAdvancedForm = this.admission.media.length > 0 && priceValid;
			if(this.shouldShowSection('advanced')) {
				return validBasicForm && validAdvancedForm;
			}
			else {
				return validBasicForm;
			}
		},
		saveChanges() {
			// Validate first...
			this.$refs.form.validate();
			if(!this.validateForm()) return;

			this.admission.attributes = Object.values(this.attributes).filter(attribute => attribute.retail_price !== null)
			if(this.admission.attributes) {
				let sortOrder = 0;
				this.admission.attributes.forEach(attribute => {
					attribute.sort_order = sortOrder++;
				})
			}

			passHelpers.saveChanges(this.isSaving, this.partner, this.admission, this.getReturnUrl());

		}
	}
};

</script>
